import { render } from "./energysave.vue?vue&type=template&id=41f6cd08"
import script from "./energysave.vue?vue&type=script&lang=js"
export * from "./energysave.vue?vue&type=script&lang=js"

import "./energysave.vue?vue&type=style&index=0&id=41f6cd08&lang=less"
script.render = render

export default script